import axios from 'axios'
import Swiper, { Autoplay, EffectFade, Navigation, Pagination } from 'swiper'
import 'swiper/swiper-bundle.css'
import store from '../../store'
import { kNumberFormater, qs, qsa } from '../../utils'
import DefaultRenderer from './Default'
Swiper.use([Navigation, Pagination, EffectFade, Autoplay])

const states = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CZ: 'Canal Zone',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District of Columbia',
  FL: 'Florida',
  GA: 'Georgia',
  GU: 'Guam',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VI: 'Virgin Islands',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
}

class ImpactRenderer extends DefaultRenderer {
  constructor(opts) {
    super(opts)
  }

  initRender() {
    store.resizeFn = null
    store.section = 'impact'
    this.setUpMap()
    this.onPageChange()
    this.setUpVideo()
    this.initSlides()
  }

  onEnter() {
    super.onEnter()
    qs('.disclaimer')?.classList?.remove?.('hide')
    qs('.disclaimer')?.classList?.add?.('impact')
  }

  onLeave() {
    super.onLeave()
    qs('.disclaimer')?.classList?.add?.('hide')
    qs('.disclaimer')?.classList?.remove?.('impact')
  }

  onEnterCompleted() {
    super.onEnterCompleted()
    this.initRender()
  }

  onLeaveCompleted() {
    super.onLeaveCompleted()
  }

  initSlides() {
    qsa('.video-slide').forEach((s, ind) => {
      new Swiper(s, {
        slidesPerView: 1,
        spaceBetween: 50,
        centeredSlides: true,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        loop: true,
        on: {
          slideChange: function () {
            if (this.pagination.bullets) {
              this.pagination.bullets.forEach((el, index) =>
                el.setAttribute('aria-current', `${index === this.realIndex}`),
              )
            }
          },
          paginationRender: function (swiper, el) {
            el.querySelectorAll('.swiper-pagination-bullet').forEach(function (child) {
              child.setAttribute(
                'aria-label',
                child.getAttribute('aria-label').replace('total', swiper.pagination.bullets.length),
              )
            })
          },
        },
        speed: 1000,
        pagination: {
          el: `.video-slide-dots-${ind + 1}`,
          clickable: true,
          renderBullet: function (index, className) {
            const ariaLabel = `go to video ${index + 1} out of total`
            const ariaCurrent = index === 0 ? ' aria-current="true" ' : ''
            return `<button ${ariaCurrent} class="${className}" aria-label="${ariaLabel}" data-track="Scroll buttons - Impact" data-component="buttons"></button>`
          },
        },
      })
    })
    let autoplayObj = {
      autoplay: {
        delay: 4000,
        waitForTransition: true,
        disableOnInteraction: false,
      },
    }
    const heroSlide = new Swiper('.hero-slide-text', {
      slidesPerView: 'auto',
      spaceBetween: 50,
      centeredSlides: true,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      autoHeight: true,
      loop: true,
      speed: 1000,
      navigation: {
        nextEl: '.h-s-next',
        prevEl: '.h-s-prev',
      },
      breakpoints: {
        900: {
          ...autoplayObj,
        },
      },
      on: {
        init: function (swiper) {
          qsa('.hero-slide-text .swiper-slide').forEach(function (el) {
            el.setAttribute('aria-hidden', 'true')
            el.style.visibility = 'hidden'
          })
          const elem = qs('.hero-slide-text .swiper-slide-active').setAttribute(
            'aria-hidden',
            'false',
          )
          if (elem) {
            elem.style.visibility = 'visible'
          }
        },
        slideChange: function (swiper) {
          var myslide = swiper.activeIndex
          qsa('.hero-slide-text .swiper-slide').forEach(function (el) {
            el.setAttribute('aria-hidden', 'true')
            el.style.visibility = 'hidden'
          })
          setTimeout(function () {
            var elem = qs('.swiper-slide-active')
            if (elem) {
              elem.setAttribute('aria-hidden', 'false')
              elem.style.visibility = 'visible'
            }
          }, 0)
        },
      },
      keyboard: {
        enabled: true,
      },
    })
  }
  setUpMap() {
    const defaultRadiusMultiplier = 6
    try {
      axios
        .get('https://d3jlszua3q4cyr.cloudfront.net/content/web/opens-by-state.csv')
        .then((response) => {
          const arr = response.data.split('\n')
          const total = arr.filter((c) => c).reduce((t, c) => t + parseFloat(c.split(',')[0]), 0)
          arr.map((c, i) => {
            const [qty, id] = c.split(',')
            const $g = qs(`#US-${id}`)
            const $gHover = qs(`#US-${id}-hover`)
            if (id && $g && $gHover) {
              const $text = qs('text', $g)
              const $hidden = qs('.visually-hidden', $g)
              const $circle = qs('circle', $g)
              const percentage = (qty * 100) / total
              const textNumber = kNumberFormater(qty)

              if ($text && $circle) {
                $circle.setAttribute('r', defaultRadiusMultiplier * percentage)
                if (percentage > 10) {
                  $circle.style.fill = 'rgba(0, 0, 0, 0.6)'
                } else if (percentage > 7) {
                  $circle.style.fill = 'rgba(0, 0, 0, 0.75)'
                }

                let minRadius = 30
                if (i < 5) {
                  $g.classList.add('featured')
                }
                if (textNumber.length >= 5) {
                  minRadius = 45
                }

                const r = parseFloat($circle.getAttribute('r'))
                $gHover.addEventListener('mouseover', () => {
                  $circle.setAttribute('r', `${r < minRadius ? minRadius : r * 1.1}`)
                  $text.style.fill = 'rgba(256,256,256,1)'
                  $text.style.transitionDelay = '.1s'
                })
                $gHover.addEventListener('mouseleave', () => {
                  $circle.setAttribute('r', `${r}`)
                  $text.style.fill = 'rgba(256,256,256,0)'
                  $text.style.transitionDelay = '0s'
                })
                $gHover.addEventListener('focusout', () => {
                  $circle.setAttribute('r', `${r}`)
                  $circle.style.stroke = 'transparent'
                  $circle.style.strokeWidth = '0'
                  $text.style.fill = 'rgba(256,256,256,0)'
                  $text.style.transitionDelay = '0s'
                })
                $gHover.addEventListener('focus', () => {
                  $circle.setAttribute('r', `${r < minRadius ? minRadius : r * 1.1}`)
                  $circle.style.stroke = 'var(--magenta)'
                  $circle.style.strokeWidth = '3'
                  $text.style.fill = 'rgba(256,256,256,1)'
                  $text.style.transitionDelay = '.1s'
                })
                const amount = textNumber.includes('k') ? textNumber.replace('k', '') : textNumber
                $text.textContent = `${textNumber}`
                $hidden.textContent = `${amount} ${
                  textNumber.includes('k') ? 'thousands' : ''
                } App openings in ${states[id]} state`
              }
            }
          })
        })
    } catch (error) {
      console.log(error)
    }
  }

  setUpVideo() {
    const $parent = qsa('.video-mask')
    $parent.forEach(($mask) => {
      const $iframe = qs('iframe', $mask)
      const $trigger = qs('img', $mask)

      $trigger.addEventListener('click', () => {
        $iframe.src += '?autoplay=1&showinfo=0&controls=1&disablekb=1'
        $mask.classList.add('active')
      })
      const $svg = qs('.play', $mask)
      $svg.addEventListener('keypress', function (e) {
        if (e.key === 'Enter') {
          $iframe.src += '?autoplay=1&showinfo=0&controls=1&disablekb=1'
          $mask.classList.add('active')
        }
      })
    })
  }
}

export default ImpactRenderer
